import Navbar from '../NavBar/NavBarSGI'
import React, { useEffect, useState } from "react";
import Conexao from '../../Config/conexao';
import axios from 'axios';
import { Chart } from 'react-google-charts';
import Navbar2 from '../NavBar/NavBarSGI2';
import { Container, ContainerForm, TextFieldStyled } from "./styles";
import Button from 'react-bootstrap/Button';
import { Row, Col, Offcanvas } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';




export default function DashBoardSGI() {

  const [pegaStatu, setPegaStatu] = useState([]);
  const [dataOrigens, setDataOrigens] = useState([]);
  const [dataOrigens2, setDataOrigens2] = useState([]);
  const [dataReincidente, setDataReicidente] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);
  const [analitico, setAnalitico] = useState([]);
  const [backgroundImage, setBackgroundImage] = useState();
  const [liClicked, setLiClicked] = useState(false);
  const [liClicked3, setLiClicked3] = useState(false);
  const [setorLogado, setSetorLogado] = useState();
  const [setorDoCargo, setSetorDoCargo] = useState();
  const handleCloseSidebar = () => {
    setShowSidebar(false);
   
  }

  function carregaUser() { setSetorLogado(localStorage.usuario) };
  useEffect(() => { carregaUser() });

  async function getSetor() {
    const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
    if (res.data.success === false) {
      //  setLoading(false)
      //  falha();  
    } else {
      setSetorDoCargo(res.data.setor);
      // console.log( "SEETOOOOOR  " + setorDoCargo);
      console.log(res.data.setor);
      console.log("QUEEEEM  " + setorLogado);
    }
  };

  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    //setBackgroundImage(images[index]);

  }
  useEffect(() => { getSetor() });



  useEffect(() => {
    async function fetchData() {
      getStatu();
    }
    fetchData();
  }, []);

  async function getStatu() {
    try {
      const res = await axios.get(Conexao.api + 'ListaRegistroDeNaoConformidadeWEB.php');

      if (res.data.success === true) {
        const counts = countStatusElements(res.data.result);
        setPegaStatu(counts);

        const countsOrigens = countOrigensElements(res.data.result);
        setDataOrigens(countsOrigens);

        const countsOrigens2 = countOrigensElements2(res.data.result);
        setDataOrigens2(countsOrigens2);

        const countsReicidente = countReincidenteElements(res.data.result);
        setDataReicidente(countsReicidente);

        setAnalitico(res.data.result);

        //countOrigensElements(dataOrigens)

      }
    } catch (error) {
      // Tratar erros
    }
  };


  function countStatusElements(data) {
    let counts = {
      'Em tratamento': 0,
      'Aberto': 0,
      'Encerrado': 0,
    };

    data.forEach(item => {
      switch (item.substatu) {
        case 'Em tratamento':
          counts['Em tratamento']++;
          break;
        case 'Aberto':
          counts['Aberto']++;
          break;
        case 'Encerrado':
          counts['Encerrado']++;
          break;
        default:
          break;
      }
    });

    return counts;
  }


  function countOrigensElements(dataOrigens) {
    let countsOrigem = {
      'QSSMA': 0,
      'RH': 0,
      'Geotecnia': 0,
      'Comercial': 0,
      'Laboratório': 0,
      'Manutençao': 0,
      'Pesquisa e Mineral': 0,
      'Compras': 0,
      'Diretoria': 0,

    };
    dataOrigens.forEach(item1 => {
      switch (item1.setorOrigem) {
        case 'QSSMA':
          countsOrigem['QSSMA']++;
          break;

        case 'RH':
          countsOrigem['RH']++;
          break;

        case 'Geotecnia':
          countsOrigem['Geotecnia']++;
          break;

        case 'Comercial':
          countsOrigem['Comercial']++;
          break;

        case 'Laboratório':
          countsOrigem['Laboratório']++;
          break;

        case 'Manutençao':
          countsOrigem['Manutençao']++;
          break;

        case 'Pesquisa e Mineral':
          countsOrigem['Pesquisa e Mineral']++;
          break;

        case 'Compras':
          countsOrigem['Compras']++;
          break;
        case 'Diretoria':
          countsOrigem['Diretoria']++;
          break;
        default:
          break;
      }
    });

    return countsOrigem;

  };



  function countOrigensElements2(dataOrigens2) {
    let countsOrigem2 = {
      'Auditoria Interna': 0,
      'Auditoria Externa': 0,
      'Auditoria De Clientes': 0,
      'Oportunidade de melhoria': 0,
      'Reclamação de melhoria': 0,
      'Outros': 0,


    };
    dataOrigens2.forEach(item2 => {
      switch (item2.origem) {
        case 'Auditoria Interna':
          countsOrigem2['Auditoria Interna']++;
          break;

        case 'Auditoria Externa':
          countsOrigem2['Auditoria Externa']++;
          break;

        case 'Auditoria De Clientes':
          countsOrigem2['Auditoria De Clientes']++;
          break;

        case 'Oportunidade de melhoria':
          countsOrigem2['Oportunidade de melhoria']++;
          break;

        case 'Reclamação de melhoria':
          countsOrigem2['Reclamação de melhoria']++;
          break;

        case 'Outros':
          countsOrigem2['Outros']++;
          break;


        default:
          break;
      }
    });

    return countsOrigem2;

  };


  function countReincidenteElements(dataReincidente) {
    let countsReincidente = {
      'Sim': 0,
      'Não': 0,


    };
    dataReincidente.forEach(item3 => {
      switch (item3.reincidente) {
        case 'Não':
          countsReincidente['Não']++;
          break;

        case 'Sim':
          countsReincidente['Sim']++;
          break;


        default:
          break;
      }
    });

    return countsReincidente;

  };





  return <div className="home">

    <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1600px', minWidth: '1600px' }} >
      {/* Botao de Menu  */}
      <div className="sidebar-button">
        <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
          <div className="icon-container">
            <i className="bi bi-list icon-circle"></i>
          </div>
        </Button>

      </div>
      {/* Bandeiras */}
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>

      {/* Titulo */}
      <div className="sidebar-Text">
        <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginLeft: '20%', }}>Não Conformidades</text>
      </div>
      {/* Logica da pagina */}
      <Container>
        <ContainerForm>
          <body className='container fluid d-flex justify-content-center mt-5'>

          

              <Chart
                width={'800px'}
                height={'500px'}
                chartType="PieChart"
                loader={<div> Loading Chart </div>}
                data={[
                  ['Status', 'Quantidade'],
                  ['Em tratamento', pegaStatu['Em tratamento'] || 0],
                  ['Aberto', pegaStatu['Aberto'] || 0],
                  ['Encerrado', pegaStatu['Encerrado'] || 0],
                ]}
                options={{
                  title: 'Não conformidades por Status',
                  titleTextStyle: {
                    fontSize: 21,
                    textAlign: 'center'
                  },
                  chartArea: { width: '40%' },
                  hAxis: {
                    title: 'Status',
                    minValue: 0,
                  },
                  vAxis: {
                    title: '',
                  },
                  legend: { position: 'top' },
                  isStacked: true,
                  pieHole: 0.4,
                  pieSliceTextStyle: {
                    color: 'white',
                  },
                  colors: ['#ff9900', '#dc3912', '#3CB371'],
                }}
                legendToggle
              />


           







          </body>

          <body className='container fluid d-flex justify-content-center mt-5'>

      



              <Chart
                width={'800px'}
                height={'500px'}
                chartType="BarChart"
                loader={<div> Loading Chart </div>}
                data={[
                  ['Origens', 'Quantidade'],
                  ['QSSMA', dataOrigens['QSSMA'] || 0],
                  ['RH', dataOrigens['RH'] || 0],
                  ['Geotecnia', dataOrigens['Geotecnia'] || 0],
                  ['Comercial', dataOrigens['Comercial'] || 0],
                  ['Laboratório', dataOrigens['Laboratório'] || 0],
                  ['Manutençao', dataOrigens['Manutençao'] || 0],
                  ['Pesquisa e Mineral', dataOrigens['Pesquisa e Mineral'] || 0],
                  ['Compras', dataOrigens['Compras'] || 0],
                  ['Diretoria', dataOrigens['Diretoria'] || 0],
                ]}
                options={{
                  title: 'Não conformidades por setor de origem',
                  titleTextStyle: {
                    fontSize: 19,
                    textAlign: 'center'
                  },
                  chartArea: { width: '50%' },
                  hAxis: {
                    title: 'Setor',
                    minValue: 0,
                  },
                  vAxis: {
                    title: '',

                  },
                  legend: { position: 'top' },
                  isStacked: true,

                  colors: ['#3CB371'],
                }}
                legendToggle
              />




          </body>
          <body className='container fluid d-flex justify-content-center mt-5'>

           


              <Chart
                width={'1000px'}
                height={'500px'}
                chartType="ColumnChart"
                loader={<div> Loading Chart </div>}
                data={[
                  ['Origens', 'Quantidade'],
                  ['Auditoria Interna', dataOrigens2['Auditoria Interna'] || 0],
                  ['Auditoria Externa', dataOrigens2['Auditoria Externa'] || 0],
                  ['Auditoria De Clientes', dataOrigens2['Auditoria De Clientes'] || 0],
                  ['Oportunidade de melhoria', dataOrigens2['Oportunidade de melhoria'] || 0],
                  ['Reclamação de melhoria', dataOrigens2['Reclamação de melhoria'] || 0],
                  ['Outros', dataOrigens2['Outros'] || 0],

                ]}
                options={{
                  title: 'Origem das não conformidades ',
                  titleTextStyle: {
                    fontSize: 19,
                    textAlign: 'center',
                    textShadow:'none'
                  },
                  chartArea: { width: '70%' },
                  hAxis: {
                    title: '',
                    minValue: 0,
                    textShadow:'none'
                  },
                  vAxis: {
                    title: '',
                  },
                  legend: { position: 'top' },
                  isStacked: true,
                  textShadow:'none',

                  colors: ['#3CB371'],
                }}
                legendToggle
              />



          </body>
          <body className='container fluid d-flex justify-content-center mt-5'>
            


              <Chart
                width={'800px'}
                height={'500px'}
                chartType="PieChart"
                loader={<div> Loading Chart </div>}
                data={[
                  ['Status', 'Quantidade'],
                  ['Não', dataReincidente['Não'] !== undefined ? dataReincidente['Não'] : 0],
                  ['Sim', dataReincidente['Sim'] !== undefined ? dataReincidente['Sim'] : 0],
                ]}
                options={{
                  title: 'Reincidência',
                  titleTextStyle: {
                    fontSize: 21,
                    textAlign: 'center',
                    textShadow:'none',
                  },
                  chartArea: { width: '40%' },
                  hAxis: {
                    title: 'Status',
                    minValue: 0,
                  },
                  vAxis: {
                    title: '',
                  },
                  legend: {
                    position: 'top',
                    alignment: 'center',
                    textShadow:'none',
                  },
                  isStacked: true,
                  pieHole: 0.4,
                  pieSliceTextStyle: {
                    color: 'black',
                    textShadow:'none'
                  },
                  colors: ['#3CB371', '#dc3912'],
                }}
                legendToggle
              />


     

          </body>














          <div className='container text-center d-flex mt-5 p-2 cinzaclaro'>
  <h6 className='col' style={{ color: 'black',textShadow:'none' }}> RNC</h6>
  <h6 className='col' style={{ color: 'black',textShadow:'none' }}> Origem</h6>
  <h6 className='col' style={{ color: 'black',textShadow:'none' }}> Setor </h6>
  <h6 className='col' style={{ color: 'black',textShadow:'none' }}> Reincidente</h6>
  <h6 className='col' style={{ color: 'black' ,textShadow:'none'}}> Status</h6>
</div>

<div className='scrollable container-fluid'>
  {analitico.map((a, i) => (
    <div className='container text-center d-flex' key={i}>
      {a.setorOrigem && (<h6 className='col' style={{ color: 'black' ,textShadow:'none'}}> {a.id}</h6>)}
      {a.setorOrigem && (<h6 className='col' style={{ color: 'black',textShadow:'none' }}> {a.origem}</h6>)}
      <h6 className='col' style={{ color: 'black',textShadow:'none' }}> {a.setorOrigem}</h6>
      {a.setorOrigem && (<h6 className='col' style={{ color: 'black',textShadow:'none' }}> {a.reincidente}</h6>)}
      {a.setorOrigem && (<h6 className='col' style={{ color: 'black',textShadow:'none' }}> {a.substatu}</h6>)}
    </div>
  ))}
</div>


        </ContainerForm>
      </Container>
      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
        <div className="offcanvas-header">
          
         
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <ul>
            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
              <Link to="/app/SGI" style={{ textDecoration: 'none' }}>
                <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
            </li>
            {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
              <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                <i className="bi bi-chevron-right"></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
      <br /><br />
    </div>
  </div>
};